// const backendDomain = "http://192.168.1.190:3001/api"; // local server
// const backendDomain = "http://192.168.1.254:3001/api";
// const backendDomain = "https://eveyaroot.eveya.in/api";  // live server2
// const backendDomain = "http://103.90.156.143:3001/api";  // live server1
const backendDomain = "https://eveya.in/api";  // new live server

// **
// Product apis
// plan apis
// package apis
// registration & Login apis
// Cart apis
// user api
// Address apis
// Order Api's
// sakhi order apis
// subscription and transaction by user admin
// subscription api's
// organization subscription apis
// Subscription for organization user
// vending machine apis
// organization apis
// subscrition orders   
// referal apis
// expiry Apis
// unit apis
// Quiz apis
// Reviews apis
// shipment apis
// product dimentions
// Coupon apis
// payment apis
// Entry Coupon apis
// ADMIN LOGIN API
// contact us apis
// postal apis
//  **

const SummaryApi = {
  // Product apis
  CreateProduct: {
    url: `${backendDomain}/PRODUCT_CREATE`,
    method: "POST",
  },
  getActiveProduct: {
    url: `${backendDomain}/product_retrieve_all_active`,
    method: "GET",
  },
  getAllProduct: {
    url: `${backendDomain}/product_retrieve_all`,
    method: "GET",
  },
  productImage: {
    url: `${backendDomain}/uploads`,
  },
  UpdateProduct: {
    url: `${backendDomain}/product_update`,
    method: "POST",
  },
  getProductById: {
    url: `${backendDomain}/product_retrieve_by_id`,
    method: "POST",
  },
  getActiveProductById: {
    url: `${backendDomain}/product_active_retrieve_by_id`,
    method: "POST",
  },
  getNotSakhiProducts: {
    url: `${backendDomain}/product_retrieve_not_sakhi_products`,
    method: "GET",
  },

  // plan apis
  CreatePlan: {
    url: `${backendDomain}/plan_create`,
    method: "POST",
  },
  getAllPlan: {
    url: `${backendDomain}/plan_admin_retrieve_all`,
    method: "GET",
  },
  getActivePlan: {
    url: `${backendDomain}/plan_retrieve_all_active`,
    method: "GET",
  },

  UpdatePlan: {
    url: `${backendDomain}/plan_update`,
    method: "POST",
  },

  // package apis

  CreatePackage: {
    url: `${backendDomain}/package_create`,
    method: "POST",
  },
  getAllPackage: {
    url: `${backendDomain}/package_admin_retrieve_all`,
    method: "GET",
  },
  getActivePackage: {
    url: `${backendDomain}/package_retrieve_all`,
    method: "GET",
  },

  UpdatePackage: {
    url: `${backendDomain}/package_update`,
    method: "POST",
  },
getPackageByPlanId:{
      url: `${backendDomain}/package_retrieve_by_plan_id`,
    method: "POST",
},
  // registration & Login apis

  userRegistration: {
    url: `${backendDomain}/user_create`,
    method: "POST",
  },
  generateOtp: {
    url: `${backendDomain}/user_regenerate_mobile_otp`,
    method: "POST",
  },
  VerifyOtp: {
    url: `${backendDomain}/user_login_mobile_otp`,
    method: "POST",
  },
  emailLogin: {
    url: `${backendDomain}/user_login_email`,
    method: "POST",
  },
  uploadExcel: { url: `${backendDomain}/upload_excel`, method: "POST" },

  // Cart apis
  addToCart: {
    url: `${backendDomain}/cart_create`,
    method: "POST",
  },
  getCartById: {
    url: `${backendDomain}/cart_retrieve_by_user`,
    method: "POST",
  },
  cartUpdate: {
    url: `${backendDomain}/cart_update`,
    method: "POST",
  },
  cartDelete: {
    url: `${backendDomain}/cart_delete`,
    method: "POST",
  },
  addToCart: {
    url: `${backendDomain}/cart_create`,
    method: "POST",
  },
  getCartById: {
    url: `${backendDomain}/cart_retrieve_by_user`,
    method: "POST",
  },

  //user api
  allUser: {
    url: `${backendDomain}/non_organization_user_retrieve_all`,
    method: "GET",
  },
  organizationUsers: {
    url: `${backendDomain}/organization_user_retrieve_all`,
    method: "GET",
  },

  updateUser: {
    url: `${backendDomain}/user_update`,
    method: "POST",
  },
  userDetailsById: {
    url: `${backendDomain}/user_active_retrieve_by_id`,
    method: "POST",
  },
  userProfileImage: {
    url: `${backendDomain}/uploads`,
  },
  userOrderCount: {
    url: `${backendDomain}/user_order_count`,
    method: "POST",
  },
  // Address apis
  addressCreate: {
    url: `${backendDomain}/address_create`,
    method: "POST",
  },
  getUserAddress: {
    url: `${backendDomain}/address_retrieve_all`,
    method: "GET",
  },
  getUserAddressbyId: {
    url: `${backendDomain}/address_retrieve_by_user`,
    method: "POST",
  },
  UserImage: {
    url: `${backendDomain}/uploads`,
  },
  defaultAddressUpdate: {
    url: `${backendDomain}/address_update_default`,
    method: "POST",
  },
  addressUpdate: {
    url: `${backendDomain}/address_update`,
    method: "POST",
  },
  addressDelete: {
    url: `${backendDomain}/address_delete`,
    method: "POST",
  },
  // Order Api's
  placeOrder: {
    url: `${backendDomain}/order_create`,
    method: "POST",
  },
  getOrdersById: {
    url: `${backendDomain}/order_by_user`,
    method: "POST",
  },
  OrderByCustomers: {
    url: `${backendDomain}/order_by_user`,
    method: "POST",
  },

  OrderDetailsById: {
    url: `${backendDomain}/order_by_id`,
    method: "POST",
  },

  allorders: {
    url: `${backendDomain}/order_all`,
    method: "GET",
  },

  today_all_orders: {
    url: `${backendDomain}/today_all_orders`,
    method: "GET",
  },
  CustomerOrderUpdateStatus: {
    url: `${backendDomain}/order_update`,
    method: "POST",
  },
  // Sakhi order apis
  SakhiOrderCreate: {
    url: `${backendDomain}/sakhi_order_create`,
    method: "POST",
  },
  getSakhiOrdersById: {
    url: `${backendDomain}/sakhi_order_by_user`,
    method: "POST",
  },
  getAllSakhiOrders: {
    url: `${backendDomain}/sakhi_order_all`,
    method: "GET",
  },
  //subscription and transaction by user admin

  subscriptionbyuseradmin: {
    url: `${backendDomain}/subscription_by_user`,
    method: "POST",
  },

  subscriptionbyuseradmin: {
    url: `${backendDomain}/subscription_by_user`,
    method: "POST",
  },

  transactionsbyuser: {
    url: `${backendDomain}/transactions_by_user`,
    method: "POST",
  },

  allorders: {
    url: `${backendDomain}/order_all`,
    method: "GET",
  },

  // subscription api's
  subscriptionCreate: {
    url: `${backendDomain}/subscription_create`,
    method: "POST",
  },
  getSubscriptionByUser: {
    url: `${backendDomain}/subscription_by_user`,
    method: "POST",
  },
  getAllSubscription: {
    url: `${backendDomain}/subscription_all`,
    method: "GET",
  },
  // organization subscription apis
organization_subscription_create:{
  url:`${backendDomain}/organization_subscription_create`,
  method:"POST"
},
getorgsubscriptionbyorgid:{
   url:`${backendDomain}/organization_subscription_admin_retrieve_by_organization`,
  method:"POST"
},
getActiveOrganizationSubscription:{
  url:`${backendDomain}/organization_subscription_retrieve_by_organization`,
  method:"POST"
},

// Subscription for organization user
organizationUserSubscriptionCreate:{
  url:`${backendDomain}/organization_user_subscription_create`,
  method:"POST"
},
  // vending machine apis
  vendingMachineCreate: {
    url: `${backendDomain}/vending_machine_create`,
  },
  vendingMachineUpdate: {
    url: `${backendDomain}/vending_machine_update`,
  },
  VendingMeching: {
    url: `${backendDomain}/vending_machine_admin_retrieve_all`,
  },

  //vending machine apis
  vendingMachineCreate: {
    url: `${backendDomain}/vending_machine_create`,
  },
  vendingMachineUpdate: {
    url: `${backendDomain}/vending_machine_update`,
  },

  VendingMeching: {
    url: `${backendDomain}/vending_machine_admin_retrieve_all`,
  },

  // organization apis
  organizationCreate: {
    url: `${backendDomain}/organization_create`,
  },
  organizationUpdate: {
    url: `${backendDomain}/organization_update`,
  },
  getOrganization: {
    url: `${backendDomain}/organization_admin_retrieve_all`,
    method: "GET",
  },
  getOrganizationbyid: {
    url: `${backendDomain}/organization_admin_retrieve_by_id`,
  },
  Order_withdraw_pads: {
    url: `${backendDomain}/order_withdraw_pads`,
    method: "POST",
  },
  getActiveOrganization: {
    url: `${backendDomain}/organization_retrieve_all`,
    method: "GET",
  },

  getalldashboardcounts: {
    url: `${backendDomain}/dashboard_counts`,
    method: "GET",
  },
  getallTodayOrders: {
    url: `${backendDomain}/today_all_orders`,
    method: "GET",
  },
  // subscrition orders
  subscriptionOrderCreate: {
    url: `${backendDomain}/subscription_order_create`,
    method: "POST",
  },
  Order_withdraw_pads: {
    url: `${backendDomain}/order_withdraw_pads`,
    method: "POST",
  },
  pads_count_balance: {
    url: `${backendDomain}/pad_count_retrieve_by_user_id`,
    method: "POST",
  },

  //referal apis
  apply_referral: {
    url: `${backendDomain}/apply_referral`, 
    method: "POST",
  },
  wallet_ref_transaction_by_referral:{
    url: `${backendDomain}/wallet_ref_transaction_by_referral`,
    method: "POST",
  },
  getAllReferral: {
    url: `${backendDomain}/wallet_ref_transaction_all`,
    method: "GET",
  },
  user_active_code_retrieve_by_id: {
    url: `${backendDomain}/user_active_code_retrieve_by_id`,
    method: "POST",
  },

  wallet_points: {
    url: `${backendDomain}/wallet_retrieve_by_user`,
    method: "POST",
  },

  wallet_ref_transaction_by_referral: {
    url: `${backendDomain}/wallet_ref_transaction_by_referral`,
    method: "POST",
  },

  subscriptionOrderCreate: {
    url: `${backendDomain}/subscription_order_create`,
    method: "POST",
  },
  Order_withdraw_pads: {
    url: `${backendDomain}/order_withdraw_pads`,
    method: "POST",
  },
  pads_count_balance: {
    url: `${backendDomain}/pad_count_retrieve_by_user_id`,
    method: "POST",
  },
  subscription_traanstion_by_user: {
    url: `${backendDomain}/transactions_by_user`,
    method: "POST",
  },

  subscription_order_by_user: {
    url: `${backendDomain}/subscription_order_by_user`,
    method: "POST",
  },

  plan_admin_retrieve_by_id: {
    url: `${backendDomain}/plan_admin_retrieve_by_id`,
    method: "POST",
  },

  package_retrieve_by_id: {
    url: `${backendDomain}/package_retrieve_by_id`,
    method: "POST",
  },
  subscriptionOrderCreate: {
    url: `${backendDomain}/subscription_order_create`,
    method: "POST",
  },
  Order_withdraw_pads: {
    url: `${backendDomain}/order_withdraw_pads`,
    method: "POST",
  },
  pads_count_balance: {
    url: `${backendDomain}/pad_count_retrieve_by_user_id`,
    method: "POST",
  },
  subscription_traanstion_by_user: {
    url: `${backendDomain}/transactions_by_user`,
    method: "POST",
  },
  subscription_renewal: {
    url: `${backendDomain}/renewal_subscription_create`,
    method: "POST",
  },

  // expiry Apis

  expiry_subscription_by_user: {
    url: `${backendDomain}/user_expire_subscription_packs`,
    method: "POST",
  },
  // unit apis
  product_unit_create: {
    url: `${backendDomain}/product_unit_create`,
    method: "POST",
  },
  product_unit_admin_retrieve_all: {
    url: `${backendDomain}/product_unit_admin_retrieve_all`,
    method: "GET",
  },
  product_unit_update: {
    url: `${backendDomain}/product_unit_update`,
    method: "POST",
  },
  product_unit_admin_retrieve_by_id: {
    url: `${backendDomain}/product_unit_admin_retrieve_by_id`,
    method: "POST",
  },

  googleLogin: {
    url: `${backendDomain}/user_google_signup`,
    method: "post",
  },

  // Quiz apis
  updateQuizStatus: {
    url: `${backendDomain}/update_user_quiz`,
    method: "POST",
  },
  quiz_create: {
    url: `${backendDomain}/quiz_create`,
    method: "POST",
  },
  update_user_quiz_QA: {
    url: `${backendDomain}/quiz_update`,
    method: "POST",
  },
  user_dashboard_counts: {
    url: `${backendDomain}/user_dashboard_counts`,
    method: "POST",
  },

  // Reviews apis
  review_create: {
    url: `${backendDomain}/review_create`,
    method: "POST",
  },

  review_update: {
    url: `${backendDomain}/review_update`,
    method: "POST",
  },

  getuserrating: {
    url: `${backendDomain}/review_active_by_product_user`,
    method: "POST",
  },

  getusersakhirating: {
    url: `${backendDomain}/review_active_by_user_order`,
    method: "POST",
  },
  getusersubscriptionrating: {
    url: `${backendDomain}/review_active_by_user_subscription`,
    method: "POST",
  },
  getAllAdminReviews: {
    url: `${backendDomain}/review_admin_retrieve_all`,
    method: "GET",
  },
  getActiveReviews: {
    url: `${backendDomain}/review_retrieve_all`,
    method: "GET",
  },
  // shipment apis

  ShippingCreate: {
    url: `${backendDomain}/order_update_nimbus`,
    method: "POST",
  },
  trackOrderById:{
     url: `${backendDomain}/order_track_nimbus`,
    method: "post",
  },
  // product dimentions
  createProductDimensions: {
    url: `${backendDomain}/dimensions_create`,
    method: "POST",},
getAllDimensions: {
    url: `${backendDomain}/dimensions_retrieve_all`,
    method: "GET",},
    updateProductDimensions: {
    url: `${backendDomain}/dimensions_update`,
    method: "POST",},
  // Coupon apis
  coupon_create: {
    url: `${backendDomain}/coupon_create`,
    method: "POST",
  },
  coupon_admin_retrieve_all: {
    url: `${backendDomain}/coupon_admin_retrieve_all`,
    method: "GET",
  },
  coupon_update: {
    url: `${backendDomain}/coupon_update`,
    method: "POST",
  },
  validate_coupon:{
    url: `${backendDomain}/validate_coupon`,
    method: "POST",
  },
  // payment apis

  createPaymentIntent: {
    url: `${backendDomain}/create_checkout`,
    method: "POST",
  },
  
  // Entry Coupon apis
  createBulkEntryCoupon: {
    url: `${backendDomain}/bulk_coupon_batch_create`,
    method: "POST", 
  },
  createEntryCoupon: {
    url: `${backendDomain}/entry_coupon_create`,
    method: "POST", 
  },
getCouponsByOrg: {
    url: `${backendDomain}/entry_coupon_retrieve_by_organization`,
    method: "POST"
},
getBulkCouponBatches: {
  url: `${backendDomain}/entry_coupon_retrieve_all_active`,
  method: "GET"
},
// ADMIN LOGIN API
adminLogin: {
  url: `${backendDomain}/admin_login`,
  method: "POST",
},
AdminChangePassword: {
  url: `${backendDomain}/password_update`,
  method: "POST",
},

// contact us apis
contactUs: {
  url: `${backendDomain}/contact_us_create`,
  method: "POST",
},
// postal apis
indiaPostLogin: {
    url: "https://api.nimbuspost.com/v1/users/login",
    method: "POST"
  },
  getSpeedPostTariff: {
    url: "https://test.cept.gov.in/beextcustomer/v1/speed-post/tariffs",
    method: "GET"
  },
   createShipment: {
    url: "https://api.nimbuspost.com/v1/shipments",
    method: "POST"
  }
};
export default SummaryApi;
